<template>

</template>

<script>
export default {
  name: 'Tutorial',
  activated() {
    if (window.size.desktop && window.scrollY > 120) {
      window.scrollTo(0, 120);
    }
    document.getElementById('betting-container').style.height = 'auto';
  },
};
</script>

<style scoped>

</style>